// components/InstallButton.jsx
export default function InstallButton({
  isInstalled,
  isInstalling,
  onDirectInstall,
  onStartRapid
}) {
  const handleClick = () => {
    if (isInstalled) {
      window.open("/index.html?pwa=1", "_blank")
      console.log("try open in pwa mode");
    } else if (!isInstalling) {
      window.deferredPrompt ? onDirectInstall() : onStartRapid();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`relative 
        mx-auto                  {/* 水平居中 */}
        w-auto 
        min-w-[300px]            {/* 新增：最小宽度 300px */}
        max-w-lg                 {/* 原来 max-w-xs（≈256px）→ 现在 max-w-lg（≈512px），但实际会在手机上停在 ≈360-400px 左右，非常完美 */}
        inline-flex 
        px-10 py-3.5             {/* 水平内边距再大一点，手感更好；高度从 py-3 → py-3.5 稍微回一点点 */}
        rounded-full 
        text-lg font-semibold 
        items-center justify-center gap-3
        transition-all shadow-md hover:shadow-xl
        overflow-hidden group ${isInstalled
          ? 'bg-green-600 text-white hover:bg-green-700'
          : 'bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700'
        }`}
    >
      {/* 文字 & 图标 */}
      {isInstalled ? (
        <>OPEN & PLAY</>
      ) : isInstalling ? (
        <>Installing, please wait...</>
      ) : (
        <>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Rapid Install
        </>
      )}

      {/* 扫光效果保持不变 */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-shine pointer-events-none" />
    </button>
  );
}